import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';

export interface IApryseEventState {
    currentPage: number;
    currentScale: number;
    selectedAnnotationIds: string[];
}

export const apryseEventSlice = createSlice({
    name: 'apryseEvent',
    initialState: {
        currentPage: 1,
        currentScale: 1,
        selectedAnnotationIds: [],
    } as IApryseEventState,
    reducers: {
        updateSelectedAnnotations: (state, action: PayloadAction<string[]>) => {
            state.selectedAnnotationIds = action.payload;
        },
        updateCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        updateCurrentScale: (state, action: PayloadAction<number>) => {
            state.currentScale = action.payload;
        },
    },
});

export const apryseEventSliceCurrentPage = (state: IGlobalStoreReducers) =>
    state.apryseEvent.currentPage;
export const apryseEventSliceCurrentScale = (state: IGlobalStoreReducers) =>
    state.apryseEvent.currentScale;
export const apryseEventSliceSelectedAnnotationIds = (state: IGlobalStoreReducers) =>
    state.apryseEvent.selectedAnnotationIds;

export default apryseEventSlice.reducer;
